export function urlFormat(str, settings) {
	let opt = {
			delimiter: '-',
			toLower: true,
			alphaChar: false,
			alphaNumeric: false,
			removeExtension: true,
			removeHyphen: false,
			stripLastHyphen: false,
			capitaliseAll: false,
			capitaliseAllCorrect: false,
			// [{ abbreviation : 'rc',value:'rugby club'}]
			matchString: []
		},
		options = $.extend(opt, settings, {});
	if (str.length <= 0) {
		return
	}
	str = str.replace(/[\(-\)-\{-\}]/g, ' ');

	if (options.removeExtension) {
		str = str.replace(/\.[^/.]+$/, ' ');
	}
	if (options.removeHyphen) {
		str = str.replace(/-/g, ' ');
	}
	if (options.alphaChar) {
		str = str.replace(/[^a-zA-Z]/g, ' ');
	}
	else if (options.alphaNumeric) {
		str = str.replace(/[^a-zA-Z0-9]/g, ' ');
	}
	if (options.toLower) {
		str = str.toLowerCase(); // validate to lower case only
	}
	// remove underscores
	str = str.replace(/_/g, ' ');

	str = str.replace(/( )\1+/g, '$1'); //replace duplicate spaces with one

	str = str.replace(/( )/g, options.delimiter); //replace spaces with delimiter

	//remove first character if ots a delimiter
	let regex = new RegExp('^' + options.delimiter);
	str = str.replace(regex, '');

	if (options.stripLastHyphen) {
		regex = new RegExp(options.delimiter + '$');
		str = str.replace(regex, '');
	}
	if (options.matchString.length > 0) {
		str = matchString(str, options.matchString);
	}

	if (options.capitaliseAll) {
		str = capitaliseAll(str, false);
	}
	else if (options.capitaliseAllCorrect) {
		str = capitaliseAll(str, true);
	}

	return str;
}

function matchString(str, teams) {
	for (let i = 0; i < teams.length; ++i) {
		let replace = teams[i].replace,
			find = teams[i].find;

		str = replaceWordInString(find, str, replace);

		// console.log('str', str);
	}
	return str;
}

function replaceWordInString(find, str, replace) {
	let regex = new RegExp('\\b' + find + '\\b', 'i');
	// console.log('find', find, 'str', str, 'replace', replace);
	return str.replace(regex, replace);
}

function capitaliseAll(str, lower) {

	if (lower) {
		str = str.toLowerCase();
	}
	return str.replace(/(?:^|\s)\S/g, function (a) {
		return a.toUpperCase();
	});
}


// WEBPACK FOOTER //
// ./resources/assets/js/urlFormat.js